/**
 * Creates a matcher function for RTK Query actions
 * @param {string} apiName - The name of the API (e.g., 'authApi')
 * @param {string} endpointName - The name of the endpoint (e.g., 'login')
 * @param {'mutation'|'query'} type - The type of action ('mutation' or 'query')
 * @param {'pending'|'fulfilled'|'rejected'} status - The status of the action
 * @returns {function} A matcher function that can be used with addMatcher
 */
export const createActionMatcher = (apiName, endpointName, type, status) => {
  const actionType = `${apiName}/execute${type.charAt(0).toUpperCase() + type.slice(1)}/${status}`;

  return (action) => {
    return action.type === actionType && action.meta?.arg?.endpointName === endpointName;
  };
};

/**
 * Shorthand for creating a mutation action matcher
 */
export const createMutationMatcher = (apiName, endpointName, status) => {
  return createActionMatcher(apiName, endpointName, "mutation", status);
};

/**
 * Shorthand for creating a query action matcher
 */
export const createQueryMatcher = (apiName, endpointName, status) => {
  return createActionMatcher(apiName, endpointName, "query", status);
};
